'use strict';
module.exports = function (obj) {
	if (typeof obj !== 'object') {
		throw new TypeError('Expected an object');
	}

	var ret = {};

	for (var key in obj) {
		var val = obj[key];
		ret[val] = key;
	}

	return ret;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/invert-kv/index.js
// module id = 239
// module chunks = 0